// Ancien filtre « pluralize » de vue2-filters : le mot, suivi d'un « s » sauf pour 1.
export function pluralize(value, word) {
  return word + (value === 1 ? '' : 's');
}
